<nav class="navbar navbar-expand-sm navbar-light bg-light h-100" style="--bs-navbar-padding-y: 0.23rem">
	<div class="container-fluid d-flex align-items-center h-100">

		<a class="navbar-brand" routerLink="/" title="MyAon">
			<app-logo />
		</a>

        <div class="d-flex h-100 justify-content-center align-items-center"></div>

		<div class="flex-grow-1 d-flex align-items-center justify-content-center h-100">

            <dx-menu class="h-100" height="100%" [items]="$navigation()" selectionMode="none">
                <a  role="button" class="navbar-menu-parent"
                    *dxTemplate="let item of 'parentTemplate'"
                    [ngClass]="{ 'dx-menu-item-selected': isModuleActive(item) }">

                    @switch (iconType(item)) {
                        @case ('fa') {
                            <i class="dx-icon fa-fw fa-lg" [ngClass]="item.icon.fa"></i>
                        }
                        @case ('bi') {
                            <i class="dx-icon bi" [ngClass]="item.icon.bi"></i>
                        }
                        @case ('mat') {
                            <i class="dx-icon material-icons">{{ item.icon.mat }}</i>
                        }
                        @case ('txt') {
                            <span class="dx-icon">{{ item.icon.txt }}</span>
                        }
                    }
                    <span class="dx-menu-item-text" [class.ms-1]="iconType(item)">{{ (item.label || item.title || '') | translate }}</span>
                    <i class="fa-fw fa-solid fa-chevron-down dropdown-chevron small" aria-hidden="true"></i>
                </a>

                <a
                    role="link"
                    class="navbar-menu-link"
                    *dxTemplate="let item of 'linkTemplate'"
                    [routerLink]="routerLink(item.path, item.parentPath)"
                    [queryParams]="routerParams(item)"
                    [ngClass]="{ 'dx-menu-item-selected': isModuleActive(item) }">

                    <span class="dx-menu-item-text">{{ (item.label || item.title || '') | translate }}</span>
                    @switch (iconType(item)) {
                        @case ('fa') {
                            <i class="dx-icon fa-fw fa-lg" [ngClass]="item.icon.fa"></i>
                        }
                        @case ('bi') {
                            <i class="dx-icon bi" [ngClass]="item.icon.bi"></i>
                        }
                        @case ('mat') {
                            <i class="dx-icon material-icons">{{ item.icon.mat }}</i>
                        }
                        @case ('txt') {
                            <span class="dx-icon">{{ item.icon.txt }}</span>
                        }
                    }
                </a>
            </dx-menu>

		</div>


        <!-- AFTER -->

        <app-language-selector class="ms-1"></app-language-selector>
        @if (canReadGeneralDocumentation) {
            <dx-button routerLink="/home/documentation" class="ms-1" icon="bi bi-question-circle-fill" [hint]="'PAGE_TITLE.DOCUMENTATION' | translate"></dx-button>
        }

         <a id="profileBtn" class="ms-1 btn border d-flex justify-content-center align-items-center">
            @if ($userInfo()) {
                {{$userSignature()}}
            }
            @else {
                <i class="fa-solid fa-user"></i>
            }
         </a>
         
        <dx-popover
            target="#profileBtn"
            showEvent="click"
            position="bottom"
            [width]="400"
        >
            <div *dxTemplate="let data of 'content'">
                <div class="d-flex align-items-center justify-content-stretch">
                    <i class="bi bi-person-circle fa-fw fa-3x text-secondary me-2"></i>
                    <div class="d-flex flex-column">
                        <span class="h6 m-0">{{ $userInfo()?.Name }}</span>
                        <span class="text-muted" style="font-size: 0.85em;">{{ $userInfo()?.Email }}</span>
                        @if($userClientPrimary()){
                             <span class="h6 text-capitalize mb-0" style="color: var(--uui-navy);">{{$userClientPrimary()}}</span>
                            @if ($userClientSplit()) {
                                <span class="text-muted text-capitalize" style="font-size: 0.85em; color: var(--uui-navy);">{{ $userClientSecondary() }}</span>
                            }
                        }

                    </div>
                </div>
            </div>
        </dx-popover>

        <dx-button class="ms-1" icon="bi bi-box-arrow-right" [hint]="'AUTHENTICATION.ACTION_LOGOUT' | translate" (onClick)="logout()"></dx-button>
        <!-- NAV AFTER | end -->
	</div>
</nav>
